/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { AgentStatus } from 'CalltakingCoreApi';

export const HEADSET_DISCONNECTED = 'HEADSET_DISCONNECTED';

export type RelayTriggerStatus = AgentStatus | typeof HEADSET_DISCONNECTED;

export function isAgentStatusApplicable(triggerStatus: RelayTriggerStatus, status: AgentStatus): boolean {
    switch (status) {
        case 'ON_CALL':
        case 'HOLDING_CALL':
        case 'ON_ACD_CALL':
            return triggerStatus === 'ON_CALL';
        default:
            return triggerStatus === status;
    }
}

/**
 * Resolves whether a relay mapped to the given trigger status should be energized.
 */
export function isRelayEnergized(triggerStatus: RelayTriggerStatus, status: AgentStatus, headsetConnected: boolean): boolean {
    return isAgentStatusApplicable(triggerStatus, status) || (triggerStatus === HEADSET_DISCONNECTED && !headsetConnected);
}
